import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Button from "@mui/material/Button";
import TableCell from "@mui/material/TableCell";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";
import React from "react";

// mui-datatables 4 wraps a second role=button sort label inside its button.
// This adapter for the two reviewed non-draggable tables exposes sorting once.
const AccessibleTableHead = ({ column, toggleSort, sortOrder }) => {
  const sortable = column.sort !== false;
  const active = sortable && sortOrder.name === column.name;
  const direction = active ? sortOrder.direction : "none";
  const label = column.label || column.name;
  const content = column.customHeadLabelRender
    ? column.customHeadLabelRender(column)
    : label;
  const text =
    content == null ? <span style={visuallyHidden}>{label}</span> : content;
  return (
    <TableCell
      component="th"
      scope="col"
      padding="none"
      aria-sort={
        sortable
          ? direction === "asc"
            ? "ascending"
            : direction === "desc"
            ? "descending"
            : "none"
          : undefined
      }
      sx={{
        fontWeight: 500,
        backgroundColor: "background.paper",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {sortable ? (
        <Button
          color="inherit"
          data-testid={`headcol-${column.index}`}
          onClick={() => toggleSort(column.index)}
          sx={{
            minWidth: 0,
            padding: 0,
            textTransform: "none",
            font: "inherit",
          }}
        >
          {text}
          {active &&
            (direction === "desc" ? (
              <ArrowDownwardIcon fontSize="small" />
            ) : (
              <ArrowUpwardIcon fontSize="small" />
            ))}
        </Button>
      ) : (
        text
      )}
    </TableCell>
  );
};
AccessibleTableHead.propTypes = {
  column: PropTypes.object.isRequired,
  toggleSort: PropTypes.func.isRequired,
  sortOrder: PropTypes.object.isRequired,
};
export default AccessibleTableHead;
